export class User {
  _id: number;
  _role: string;
  _email: string;
  _initialized: boolean;
  _hasAcceptedCgu: boolean;
  _energyType: any;
  _firstName?: string;
  _lastName?: string;
  _usesSSO?: boolean;

  constructor(
    id: number,
    role: string,
    email: string,
    initialized: boolean,
    hasAcceptedCgu: boolean,
    energyType: any,
    firstName?: string,
    lastName?: string,
    usesSSO?: boolean,
  ) {
    this._id = id;
    this._role = role;
    this._email = email;
    this._initialized = initialized;
    this._hasAcceptedCgu = hasAcceptedCgu;
    this._energyType = energyType;
    this._firstName = firstName;
    this._lastName = lastName;
    this._usesSSO = usesSSO;
  }

  serialize() {
    return {
      id: this._id,
      role: this._role,
      email: this._email,
      initialized: this._initialized,
      hasAcceptedCgu: this._hasAcceptedCgu,
      energyType: this._energyType,
      firstName: this._firstName,
      lastName: this._lastName,
      usesSSO: this._usesSSO,
    };
  }
}
